var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isShowHTMLPreviewModal)?_c('html-preview',{attrs:{"isShowBasicInfo":!_vm.isNew},on:{"close":_vm.close}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }